import { render } from "./ModalDespesaProjeto.vue?vue&type=template&id=c0b756de&scoped=true"
import script from "./ModalDespesaProjeto.vue?vue&type=script&lang=js"
export * from "./ModalDespesaProjeto.vue?vue&type=script&lang=js"

import "./ModalDespesaProjeto.vue?vue&type=style&index=0&id=c0b756de&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0b756de"]])

export default __exports__